module.exports = __webpack_public_path__ + "img/energySaving-icon_4.027cfa2b.png";